import { MaxLengthValidatorDirective } from '../../shared/directives/max-length-validator.directive';
import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { PageTitleService } from '../../core/services/page-title.service';
import { StudioService } from '../../core/services/studio.service';
import { OwnerService } from '../../core/services/owner.service';
import { MemberService } from '../../core/services/member.service';
import { AuthStateService } from '../../core/services/auth-state.service';
import { FlashService } from '../../core/services/flash.service';
import { FlashMessageComponent } from '../../shared/components/flash-message.component';

@Component({
    selector: 'app-studio-new',
    imports: [MaxLengthValidatorDirective, RouterLink, FormsModule, FlashMessageComponent],
    template: `
<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-edit"></i>&nbsp;新規作成</span>
        </div>
        <div class="card-body">
          <div class="col-md-12"><app-flash-message></app-flash-message></div>
            <form novalidate name="studioCreateForm" #studioCreateForm="ngForm" (ngSubmit)="save(studioCreateForm)">
              <div class="col-md-12">
                @if (canManageStudioSettings) {
                <div class="form-group row">
                  <div class="col-md-6">
                    <label class="col-form-label">所属(FCオーナー)</label>
                    <select class="form-control" [(ngModel)]="form.ownerId" name="ownerId" required>
                      <option [ngValue]="null">選択してください</option>
                      @for (o of owners; track o.id) {
                        <option [ngValue]="o.id">{{ o.name }}</option>
                      }
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-6">
                    <label class="col-form-label">口座振替連携先</label>
                    <select class="form-control" [(ngModel)]="form.btMethod" name="btMethod" required>
                      <option value="">選択してください</option>
                      <option value="2">りそな</option>
                      <option value="1">アプラス</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-6">
                    <label class="col-form-label">口座振替用顧客ID@if (form.btMethod == 1) {<span>（りそな用）</span>}</label>
                    <input type="text" class="form-control" [(ngModel)]="form.trusteeCode" name="trusteeCode" pattern="^[0-9]+$" required>
                    @if (form.btMethod == 1) {
                      <small class="form-text text-muted">アプラスは固定値: 32368</small>
                    }
                  </div>
                </div>
                }
                <div class="form-group row">
                  <div class="col-md-6">
                    <label class="col-form-label">店舗名</label>
                    <input type="text" class="form-control" [(ngModel)]="form.name" name="name" required>
                  </div>
                </div>
                @if (form.ownerId != 1) {
                  <div class="form-group row">
                    <div class="col-md-6">
                      <label class="col-form-label">領収書表示名</label>
                      <input type="text" class="form-control" [(ngModel)]="form.receiptName" name="receiptName">
                    </div>
                  </div>
                }
                <div class="form-group row">
                  <div class="col-md-6">
                    <label class="col-form-label">表示ID</label>
                    <input type="text" class="form-control" [(ngModel)]="form.sortBy" name="sortBy" required>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-6">
                      <label class="col-form-label">郵便番号</label>
                      <div class="bisected-input-wrap">
                        <div class="bisected-input">
                        <input type="text" class="form-control" [(ngModel)]="form.zip1" name="zip1" pattern="^[\\x01-\\x7E]+$" required>
                      </div>
                      <span>&nbsp;</span>
                      <div class="bisected-input">
                        <input type="text" class="form-control" [(ngModel)]="form.zip2" name="zip2" pattern="^[\\x01-\\x7E]+$" required>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-6 d-flex align-items-end">
                    <button type="button" class="btn btn-primary text-white" (click)="searchZipCode()"><i class="fa s-icon-autoAddress"></i>&nbsp;住所自動入力</button>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label">住所</label>
                    <div class="quartered-input-wrap">
                      <div class="quartered-input">
                        <input type="text" class="form-control" [(ngModel)]="form.province" name="province" required>
                      </div>
                      <span>&nbsp;</span>
                      <div class="quartered-input">
                        <input type="text" class="form-control" [(ngModel)]="form.city" name="city" required>
                      </div>
                      <span>&nbsp;</span>
                      <div class="quartered-input">
                        <input type="text" class="form-control" [(ngModel)]="form.area" name="area" required>
                      </div>
                      <span>&nbsp;</span>
                      <div class="quartered-input">
                        <input type="text" class="form-control" [(ngModel)]="form.address" name="address">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-6">
                    <label class="col-form-label">地区</label>
                    <select class="form-control" [(ngModel)]="form.localNumber" name="localNumber">
                      <option value="">選択してください</option>
                      @for (l of localNumbers; track l.localNumber) {
                        <option [value]="l.localNumber">{{ l.name }}</option>
                      }
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-6">
                      <label class="col-form-label">電話番号</label>
                      <div class="trisection-input-wrap">
                      <div class="trisection-input">
                        <input type="text" class="form-control" [(ngModel)]="form.phone1" name="phone1" pattern="^[\\x01-\\x7E]+$" required>
                      </div>
                      <span>&nbsp;</span>
                      <div class="trisection-input">
                        <input type="text" class="form-control" [(ngModel)]="form.phone2" name="phone2" pattern="^[\\x01-\\x7E]+$" required>
                      </div>
                      <span>&nbsp;</span>
                      <div class="trisection-input">
                        <input type="text" class="form-control" [(ngModel)]="form.phone3" name="phone3" pattern="^[\\x01-\\x7E]+$" required>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-6">
                    <label class="col-form-label">メールアドレス</label>
                    <input type="email" class="form-control" [(ngModel)]="form.email" name="email" pattern="^[\\x01-\\x7E]+$" email required>
                  </div>
                </div>
                @if (canManageStudioSettings) {
                <div class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label">お申し込みページに利用開始日の選択を表示する</label>
                    <div class="custom-control custom-radio">
                      <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" id="is_unmanned_1" class="custom-control-input" [(ngModel)]="form.isUnmanned" name="isUnmanned" value="1">
                        <label class="custom-control-label" for="is_unmanned_1">表示する</label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" id="is_unmanned_0" class="custom-control-input" [(ngModel)]="form.isUnmanned" name="isUnmanned" value="0">
                        <label class="custom-control-label" for="is_unmanned_0">表示しない</label>
                      </div>
                    </div>
                  </div>
                </div>
                @if (form.isUnmanned == '1') {
                  <div class="form-group row">
                    <div class="col-md-12">
                      &emsp;<span class="material-icons-outlined" style="font-size: inherit;">info</span>
                      <span>選択された利用開始日を過ぎると、自動的に本登録処理が行われます。</span>
                    </div>
                    <div class="col-md-12">
                      &emsp;<span class="material-icons-outlined" style="font-size: inherit;">info</span>
                      <span>支払方法がクレジットカード以外の場合、利用開始日の選択は表示されません。</span>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label class="col-form-label">初回ご請求金額に関する注意事項</label>
                      <textarea type="text" class="form-control" rows="3" [(ngModel)]="form.note" name="note" placeholder="注意事項（255文字以内）" sfMaxLength="255"></textarea>
                    </div>
                  </div>
                }
                }
                <div class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label">お申し込みページ会員区分に「見学予約」を表示する</label>
                    <div class="custom-control custom-radio">
                      <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" id="is_displayed_tour_plan_1" class="custom-control-input" [(ngModel)]="form.isDisplayedTourPlan" name="isDisplayedTourPlan" value="1">
                        <label class="custom-control-label" for="is_displayed_tour_plan_1">表示する</label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" id="is_displayed_tour_plan_0" class="custom-control-input" [(ngModel)]="form.isDisplayedTourPlan" name="isDisplayedTourPlan" value="0">
                        <label class="custom-control-label" for="is_displayed_tour_plan_0">表示しない</label>
                      </div>
                    </div>
                  </div>
                </div>
                @if (form.isDisplayedTourPlan == '1') {
                  <div class="form-group row">
                    <div class="col-md-12">
                      &emsp;<span class="material-icons-outlined" style="font-size: inherit;">info</span>
                      <span>予約管理 > メニュー 画面にて、有効な非会員向けメニューを1つ以上作成してください。</span>
                    </div>
                  </div>
                }
                @if (canManageStudioSettings) {
                <div class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label">お申し込みページに「クレジットカード入会リンク」を表示する</label>
                    <div class="custom-control custom-radio">
                      <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" id="is_displayed_cc_link_1" class="custom-control-input" [(ngModel)]="form.isDisplayedCcLink" name="isDisplayedCcLink" value="1">
                        <label class="custom-control-label" for="is_displayed_cc_link_1">表示する</label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" id="is_displayed_cc_link_0" class="custom-control-input" [(ngModel)]="form.isDisplayedCcLink" name="isDisplayedCcLink" value="0">
                        <label class="custom-control-label" for="is_displayed_cc_link_0">表示しない</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label">会員登録メールのパターン選択</label>
                    <div class="custom-control custom-radio">
                      <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" id="registration_email_pattern_1" class="custom-control-input" [(ngModel)]="form.registrationEmailPattern" name="registrationEmailPattern" value="0">
                        <label class="custom-control-label" for="registration_email_pattern_1">通常</label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" id="registration_email_pattern_3" class="custom-control-input" [(ngModel)]="form.registrationEmailPattern" name="registrationEmailPattern" value="2">
                        <label class="custom-control-label" for="registration_email_pattern_3">事前入会</label>
                      </div>
                    </div>
                  </div>
                </div>
                }
                <div class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label">カウンセリング</label>
                    <div class="custom-control custom-radio">
                      <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" id="is_counselable_1" class="custom-control-input" [(ngModel)]="form.isCounselable" name="isCounselable" value="1">
                        <label class="custom-control-label" for="is_counselable_1">実施する</label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" id="is_counselable_0" class="custom-control-input" [(ngModel)]="form.isCounselable" name="isCounselable" value="0">
                        <label class="custom-control-label" for="is_counselable_0">実施しない</label>
                      </div>
                    </div>
                  </div>
                </div>
                @if (form.isCounselable == '1') {
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label class="col-form-label">トレーニングメニュー画像</label>
                      <div class="custom-control custom-radio">
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" id="is_machine_installed_1" class="custom-control-input" [(ngModel)]="form.isMachineInstalled" name="isMachineInstalled" value="1">
                          <label class="custom-control-label" for="is_machine_installed_1">ストレッチマシンあり</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" id="is_machine_installed_0" class="custom-control-input" [(ngModel)]="form.isMachineInstalled" name="isMachineInstalled" value="0">
                          <label class="custom-control-label" for="is_machine_installed_0">ストレッチマシン無し</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" id="is_machine_installed_2" class="custom-control-input" [(ngModel)]="form.isMachineInstalled" name="isMachineInstalled" value="2">
                          <label class="custom-control-label" for="is_machine_installed_2">オリジナルパターン</label>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                <div class="form-group row">
                  <div class="col-md-4">
                    <label class="col-form-label">店舗面積（坪数）</label>
                    <input type="number" step="0.01" class="form-control" [(ngModel)]="form.floorArea" name="floorArea">
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-6">
                    <label class="col-form-label">入退館認証方式</label>
                    <select class="form-control" [(ngModel)]="form.inoutType" name="inoutType" required>
                      <option value="">選択してください</option>
                      @for (opt of inoutTypeOptions; track opt.id) {
                        <option [value]="opt.id">{{ opt.name }}</option>
                      }
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-12 text-right">
                    <a routerLink="/studio" class="btn bg-close text-white"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</a>
                    <button type="submit" class="btn btn-success" [disabled]="saving || studioCreateForm.invalid || isInvalid()"><i class="fa s-icon-save"></i>&nbsp;保存</button>
                  </div>
                </div>
              </div>
            </form>
        </div>
      </div>
    </div>
  </div>
</div>
  `
})
export class StudioNewComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private studioService = inject(StudioService);
  private ownerService = inject(OwnerService);
  private memberService = inject(MemberService);
  private authState = inject(AuthStateService);
  private router = inject(Router);
  private flash = inject(FlashService);

  form: any = {
    ownerId: null,
    btMethod: '',
    localNumber: '',
    isDisplayedTourPlan: '0',
    isDisplayedCcLink: '0',
    isUnmanned: '0',
    registrationEmailPattern: '0',
    isCounselable: '0',
    isMachineInstalled: '0',
    inoutType: '0',
  };
  owners: any[] = [];
  localNumbers: any[] = [];
  saving = false;

  readonly inoutTypeOptions = [
    { name: '物理キー', id: '0' },
    { name: '顔認証', id: '1' },
    { name: '都度選択', id: '9' },
  ];

  get userPermission(): number { return this.authState.currentUser?.role ?? 99; }
  get canManageStudioSettings(): boolean { return this.userPermission <= 10; }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('店舗管理', 's-icon-studio');
    const [owners, localNumbers]: any[] = await Promise.all([
      this.ownerService.list('all'),
      this.studioService.getLocalNumberList(),
    ]);
    this.owners = Array.isArray(owners) ? owners : [];
    this.localNumbers = Array.isArray(localNumbers) ? localNumbers : [];
  }

  async searchZipCode(): Promise<void> {
    const zipCode = `${this.form.zip1 ?? ''}-${this.form.zip2 ?? ''}`;
    if (!zipCode || zipCode === '-') return;
    const address: any = await this.memberService.getAddress(zipCode);
    if (!address) return;
    this.form.province = address.address1;
    this.form.city = address.address2;
    this.form.area = address.address3;
    this.form.address = '';
  }

  isInvalid(): boolean {
    return ['ownerId', 'btMethod', 'trusteeCode', 'name', 'sortBy', 'zip1', 'zip2', 'province', 'city', 'area', 'phone1', 'phone2', 'phone3', 'email', 'inoutType']
      .some(key => this.form[key] === null || this.form[key] === undefined || this.form[key] === '');
  }

  async save(form?: NgForm): Promise<void> {
    if (!this.canManageStudioSettings || form?.invalid || this.isInvalid()) {
      form?.control.markAllAsTouched();
      return;
    }
    this.saving = true;
    try {
      const json = { ...this.form };
      json.status = 1;
      json.zip = `${json.zip1}-${json.zip2}`;
      json.phone = `${json.phone1}-${json.phone2}-${json.phone3}`;
      delete json.zip1; delete json.zip2;
      delete json.phone1; delete json.phone2; delete json.phone3;
      delete json.owner;
      // 未選択の地域は旧新規フォームと同じ未設定で保存する。
      if (json.localNumber === '') delete json.localNumber;
      if (json.trusteeCode === undefined || json.trusteeCode.length === 0 || json.trusteeCode === '00000') {
        json.trusteeCode = this.createDummyTrusteeCode(5);
      }
      if (Number(json.ownerId) === 1) json.receiptName = '';
      const created: any = await this.studioService.upsert(json);
      if (created?.id) {
        // 旧版 studio.js:164-167: success「店舗を新規作成しました」後に編集画面へ（編集画面の通知欄に表示）
        this.flash.create('success', '店舗を新規作成しました');
        this.router.navigate(['/studio', created.id, 'edit']);
      } else {
        this.router.navigate(['/studio']);
      }
    } finally {
      this.saving = false;
    }
  }

  private createDummyTrusteeCode(_length: number): string {
    return '00000';
  }
}
